import React, { Component } from 'react';
import { DataOperation } from '../../data/DataOperation';
import { Immocom } from '../../specifique/immocom';
import { EUICurrencyField } from '../EUI/EUICurrencyField';
import { EUINumericField } from '../EUI/EUINumericField';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUIPercentField } from '../EUI/EUIPercentageField';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheIdentificationEngagement extends Component {

    static defaultProps = {
        idOperation: undefined,
        isOpen: false,
        listOperationTVACas: [],
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        operation: {},
        peutModifierEngagement: false,
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheIdentificationEngagement.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de l'opération en cours..."
        });

        DataOperation._chargementFicheIdentification().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const retourData = responseFetch.reponseAPIobjet;
                const operation = retourData[0];
                const peutModifierEngagement = retourData[34];
                const state = { operation, peutModifierEngagement };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onBlur = (propertyName) => (event, newValue) => {
        if (!newValue && newValue !== 0) newValue = null;
        this.setState(prev => ({
            operation: { ...prev.operation, [propertyName]: newValue },
            onActiveBoutonEnregistrer: false
        }), this._onVerificationFormulaire);
    };

    _onDelayedChange = (propertyName) => (event, newValue) => {
        if (!newValue && newValue !== 0) newValue = null;
        this.setState(
            prev => ({ operation: { ...prev.operation, [propertyName]: newValue } }),
            this._onVerificationFormulaire
        );
    };

    _onOpen = () => {
        const { idOperation } = this.props;
        this.setState({ ...FicheIdentificationEngagement.defaultState });
        if (!!idOperation)
            this._chargementDonnees();
    };

    _onSave = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'opération en cours'
        });

        const { listOperationTVACas, onSave } = this.props;
        const { operation } = this.state;

        DataOperation._onEnregistrementOperation(operation, listOperationTVACas).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onVerificationFormulaire = () => {
        const { idOperation } = this.props;
        const { operation } = this.state;
        Immocom.fiche()._validationFormulaire(this, "EngagementInitialOperation", operation, !!idOperation ? "Modification" : "Création");
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { onActiveBoutonEnregistrer, operation, peutModifierEngagement } = this.state;
        const { engagementInitialCA, engagementInitialNb, qpEI, shA } = operation;

        const disabled = !peutModifierEngagement;

        return <EUIPanel
            headerText="Engagement"
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._onSave}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <EUIPercentField
                disabled={disabled}
                id="tfQPEI"
                label="QPEI"
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("qpEI")}
                value={qpEI}
            />

            <EUINumericField
                disabled={disabled}
                id="tfEngagementInitialNb"
                label="Engagement initial nb"
                min={0}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("engagementInitialNb")}
                value={engagementInitialNb}
            />

            <EUINumericField
                disabled={disabled}
                id="tfSHA"
                label="Engagement initial surface (SHA / SU)"
                min={0}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("shA")}
                suffix="m²"
                value={shA}
            />

            <EUICurrencyField
                disabled={disabled}
                id="tfEngagementInitialCA"
                label="Engagement initial CA (HT)"
                min={0}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("engagementInitialCA")}
                value={engagementInitialCA}
            />

            <EUITextField disabled label="LOGT" />

            <EUITextField disabled label="PKG SS" />

            <EUITextField disabled label="PKG EXT" />

        </EUIPanel>;

    };

};